import * as React from 'react';
export const reportingSvg = React.forwardRef(function reportingSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.836 9.219a.75.75 0 0 0-1.172-.937l-1.448 1.81-1.659-1.844a.75.75 0 0 0-1.114 0l-2.25 2.5a.75.75 0 0 0 1.114 1.004L7 9.872l1.693 1.88a.75.75 0 0 0 1.143-.034l2-2.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.5 13.5v-11A2.5 2.5 0 0 0 12 0H6.328a2 2 0 0 0-1.414.586L2.086 3.414A2 2 0 0 0 1.5 4.828V13.5A2.5 2.5 0 0 0 4 16h8a2.5 2.5 0 0 0 2.5-2.5Zm-1.5 0v-11a1 1 0 0 0-1-1H8v3.25A1.75 1.75 0 0 1 6.25 6.5H3v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1Zm-6.672-12H6.5v3.25a.25.25 0 0 1-.25.25H3v-.172a.5.5 0 0 1 .146-.353l2.829-2.829a.5.5 0 0 1 .353-.146Z',
    }),
  );
});
reportingSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var reporting = {
  category: 'icon',
  colorable: true,
  name: 'reporting',
  svg: reportingSvg,
};
